"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLearningContext = void 0;
var react_1 = require("react");
var LearningContext_1 = require("../contexts/LearningContext");
//This custom hook is responsible for consuming the learning context.
function useLearningContext() {
    var context = (0, react_1.useContext)(LearningContext_1.LearningContext);
    if (!context) {
        throw new Error('The useLearningContext must be used within an LearningProvider.');
    }
    return context;
}
exports.useLearningContext = useLearningContext;
//# sourceMappingURL=useLearningContext.js.map